import Joi from "joi";

export const companySchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  isDefault: Joi.boolean().required().label("Is Default"),
});
